import { Box, styled } from "@mui/material";

export const StyledAddMoreBox = styled(Box)(({ theme, border }) => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  gap: "23px",
  border: border ? "1px solid #0B65B5" : "1px dashed #0B65B5",
  borderRadius: theme.shape.custom.largeRadius,
  // minHeight: "323px",
  minHeight: "100%",
  padding:"41.50px 0px 27px 0px",
  backgroundColor: theme.palette.custom.assistBgColor,
  // "@media screen and (min-width: 1199px) and (max-width:1416px)": {
  //   minHeight: "389px",
  // },
  // "@media screen and (min-width: 960px) and (max-width:1081px)": {
  //   minHeight: "389px",
  // }, 


  // Rishabh : To fix the extra white space from each cards
  "@media screen and (min-width: 1199px) and (max-width:1416px)": {
    minHeight: "100%",
    padding:"41.50px 0px 27px 0px",
  },
  "@media screen and (min-width: 960px) and (max-width:1030px)": {
    minHeight: "100%",
    padding:"41.50px 0px 47px 0px",
  }, 
  "@media screen and (min-width: 1031px) and (max-width:1081px)": {
    minHeight: "100%",
    padding:"41.50px 0px 27px 0px",
  },
  "@media screen and (min-width: 1200px) and (max-width:1484px)": {
    minHeight: "100%",
    padding:"41.50px 0px 45px 0px",
  },
}));
